import { Divider, Feed, Header, Statistic } from "semantic-ui-react"
import { useSubnetMappingsOverview } from "./hooks"

const SubnetMappingsOverview = ({ directTunnelData }) => {
	const { scheduledValue, permanentValue } = useSubnetMappingsOverview(directTunnelData)

	return (
		<Feed>
			<Feed.Event>
				<Feed.Content style={{ display: "flex", flexDirection: "column" }}>
					<Header as="h3" style={{ display: "flex", justifyContent: "center" }}>
						Subnet Mappings Overview
					</Header>
					<Statistic.Group widths={2} size="mini">
						<Statistic>
							<Statistic.Label>Scheduled</Statistic.Label>
							<Statistic.Value>{scheduledValue}</Statistic.Value>
						</Statistic>
						<Statistic>
							<Statistic.Label>Permanent</Statistic.Label>
							<Statistic.Value>{permanentValue}</Statistic.Value>
						</Statistic>
					</Statistic.Group>
					<Divider />
				</Feed.Content>
			</Feed.Event>
		</Feed>
	)
}

export default SubnetMappingsOverview
